import {React, styled} from 'common'
import {Page, PageContent} from 'components/Page'
import LoginForm from 'components/Welcome/LoginForm'
import {Colors} from 'appearance'
import RegisterRow from 'components/Welcome/RegisterRow'
import useLogin from 'logic/Welcome/useLogin'
import LanaguageButton from 'components/Control/LanaguageButton'
import LoadingDots from 'components/Display/LoadingDots'
import {
    FormActionButton,
    FormCard,
    FormErrorMessage,
    FormWrapper,
} from 'components/Control/Form'

const Login = () => {
    const {
        submit,
        formControl,
        loginError,
        formErrors,
        isLoading,
        translate,
        navigate,
    } = useLogin()

    return (
        <Page noHeader noDrawer>
            <PageContent centered>
                <FormCard style={{width: 400}}>
                    <FormWrapper onSubmit={submit}>
                        <LoginForm
                            translate={translate}
                            control={formControl}
                            errors={formErrors}
                            submit={submit}
                        />
                        <SignInButton
                            sx={{my: 1}}
                            onClick={submit}
                            variant="contained"
                            type="submit">
                            {translate('signIn')}
                        </SignInButton>
                        <FormErrorMessage errorMessage={loginError} />
                    </FormWrapper>
                </FormCard>
                <BottomRow>
                    <ForgotPassword onClick={() => navigate('/forgotPassword')}>
                        {translate('forgotPassword')}
                    </ForgotPassword>
                    <LanaguageButton />
                </BottomRow>
                <RegisterRow />
            </PageContent>
            <LoadingDots isLoading={isLoading} />
        </Page>
    )
}

export default Login

const ForgotPassword = styled.button`
    background-color: transparent;
    border: none;
    color: ${Colors.TORQUISE};
    font-size: 16px;
    text-decoration: underline;
    padding: 10px 0px;
    cursor: pointer;
`
const SignInButton = styled(FormActionButton)``
const BottomRow = styled.span`
    display: flex;
    align-items: center;
    width: 400px;
    justify-content: space-between;
`
